var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ shown: _vm.isShown },attrs:{"id":"splash-screen"}},[(_vm.shownItem)?_c('div',{staticClass:"splash-item"},[_c('div',{staticClass:"image"},[_c('iframe',{attrs:{"src":_vm.shownItem.image,"frameborder":"0"}})]),(_vm.shownItem.text)?_c('div',{staticClass:"text"},[_c('h2',[_vm._v(_vm._s(_vm.shownItem.text))])]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }